import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Input, version2 } from 'ui-components/components/input';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { Text, TextType } from 'ui-components/components/text';

import { AUTH0_MFA_TYPES } from '../../../../../../../authentication/constants';
import { messages } from '../../messages';
import style from '../add-mfa-enrollment.module.less';
import { EnrollmentErrorBanner } from '../enrollment-error-banner';

/**
 * @param {object} props
 * @param {undefined|{ message: string }} props.error
 * @param {string} props.enrollmentValue
 * @param {() => void} props.onCancel
 * @param {() => void} props.onStartVerification
 * @param {() => void} props.resetError
 * @param {(arg0: string) => void} props.setEnrollmentValue
 * @param {(arg: string) => void} props.setVerificationMethod
 * @returns {React.JSX.Element}
 */
export const EmailEnrollmentForm = ({
  error,
  enrollmentValue,
  onCancel,
  onStartVerification,
  resetError,
  setEnrollmentValue,
  setVerificationMethod,
}) => {
  const onEmailChange = (e) => {
    setEnrollmentValue(e.target.value);
  };

  const submitEnrollment = useCallback(
    (e) => {
      e.preventDefault();
      setVerificationMethod(AUTH0_MFA_TYPES.email);
      onStartVerification();
    },
    [onStartVerification, setVerificationMethod],
  );

  return (
    <>
      <ModalBody className={style['add-enrollment-modal-content']}>
        <FlexColumn gap={Gap.Space16}>
          <Text textType={TextType.H3} value={messages.emailEnrollmentFormTitle} />
          <Text textType={TextType.Paragraph} value={messages.emailEnrollmentFormText} />
          <form onSubmit={submitEnrollment}>
            <Input
              className={style['email-enrollment-input']}
              focusOnMount
              label={<FormattedMessage {...messages.emailEnrollmentInputLabel} />}
              onChange={onEmailChange}
              value={enrollmentValue}
              version={version2}
            />
          </form>
          <EnrollmentErrorBanner error={error} resetError={resetError} />
        </FlexColumn>
      </ModalBody>
      <ModalFooter>
        <FlexRow className={style.footer} gap={Gap.Space16}>
          <Button onClick={onCancel} theme='tertiary'>
            <FormattedMessage {...messages.cancelButton} />
          </Button>
          <Button disabled={!enrollmentValue.length} onClick={submitEnrollment} theme='primary'>
            <FormattedMessage {...messages.sendCodeButton} />
          </Button>
        </FlexRow>
      </ModalFooter>
    </>
  );
};
